export enum AlertType {
  info = 'info',
  success = 'success',
  warning = 'warning',
  error = 'danger'
}
